export const EXSBPRICELIST_CREATE_RESET = 'EXSBPRICELIST_CREATE_RESET'
export const EXSBPRICELIST_CREATE_SET_CREATED = 'EXSBPRICELIST_CREATE_SET_CREATED'
export const EXSBPRICELIST_CREATE_SET_ERROR = 'EXSBPRICELIST_CREATE_SET_ERROR'
export const EXSBPRICELIST_CREATE_SET_VIOLATIONS = 'EXSBPRICELIST_CREATE_SET_VIOLATIONS'
export const EXSBPRICELIST_CREATE_TOGGLE_LOADING = 'EXSBPRICELIST_CREATE_TOGGLE_LOADING'
